import classnames from 'classnames/bind';
import { CardActions as MuiCardActions } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import styles from './index.scss';

const cx = classnames.bind(styles);

const CardActions = ({
  children,
  className,
  noTopPadding,
  noVerticalPadding,
  ...props
}) => (
  <MuiCardActions
    {...props}
    className={useMemo(
      () => cx({
        cardActions: true,
        noTopPadding,
        noVerticalPadding,
        className,
      }),
      [
        className,
        noTopPadding,
        noVerticalPadding,
      ],
    )}
  >
    {children}
  </MuiCardActions>
);

CardActions.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  noTopPadding: PropTypes.bool,
  noVerticalPadding: PropTypes.bool,
};

export default CardActions;
